import React from 'react'
import { Icons, CustomLinkComponent } from 'msp-components'
import { Categories, Category } from '../ProductList.types'

type PaginationProps = {
  className?: string
  categories: Categories
  selectedCategoryId: string
}

const getBaseCategory = (
  categories: Categories,
  selectedCategoryId: string
): string => {
  const entries = Object.entries(categories)
  for (const [key, value] of entries) {
    if (value.id === selectedCategoryId) {
      return key
    } else {
      const subCategory = value.categories?.find(
        (subCategory: Category) => subCategory.id === selectedCategoryId
      )
      if (subCategory) {
        return key
      }
    }
  }
}

const Pagination = ({
  className,
  categories,
  selectedCategoryId
}: PaginationProps) => {
  const categoryKeys = Object.keys(categories)

  if (categoryKeys.length === 0) {
    return <></>
  }

  const baseCategory = getBaseCategory(categories, selectedCategoryId)

  // sometimes the subcategory array still empty
  if (!baseCategory) return <></>

  const currentKey = categoryKeys?.indexOf(baseCategory) || 0

  const previousIndex =
    categoryKeys[currentKey === 0 ? categoryKeys.length - 1 : currentKey - 1]
  const previousCategory = categories[previousIndex]

  const nextIndex =
    categoryKeys[currentKey === categoryKeys.length - 1 ? 0 : currentKey + 1]
  const nextCategory = categories[nextIndex]

  const getUrl = (categoryId: string): string => {
    return `/shop/${categoryId}`
  }

  const getName = (categoryId: string): string => {
    return categories[categoryId].name
  }

  const textIconStyles =
    'font-Roboto text-14 tracking-3 fill-black stroke-black stroke-[6px] text-black underline underline-offset-4'

  return (
    <div
      className={`${textIconStyles} my-12 grid w-full grid-cols-2 place-content-between ${className}`}
    >
      <div className='flex justify-start'>
        <CustomLinkComponent
          className={'flex flex-row flex-nowrap'}
          inline={true}
          href={getUrl(previousCategory.id)}
        >
          <span className='mr-3'>
            <Icons iconName='ArrowLeft' />
          </span>
          {getName(previousCategory.id)}
        </CustomLinkComponent>
      </div>
      <div className='flex justify-end'>
        <CustomLinkComponent
          className={'flex flex-row flex-nowrap'}
          inline={true}
          href={getUrl(nextCategory.id)}
        >
          {getName(nextCategory.id)}
          <span className='ml-3'>
            <Icons iconName='ArrowRight' />
          </span>
        </CustomLinkComponent>
      </div>
    </div>
  )
}

export default Pagination
